<!-- todo: move 52 to threadfilter serice -->
@if (threadFilterService.collapseOptions.isCollapsed && hiddenRepliesCount > 0 && repliesCount < 52) {
    <div class="expand-replies text-center">
        <button class="btn btn-sm" [disabled]="!parent.loadedThread" (click)="loadMoreReplies()">
            <span translate>View</span> {{ hiddenRepliesCount }}
            <span translate>more replies</span>
        </button>
    </div>
}
@if (repliesCount >= 52 && hiddenRepliesCount > 0) {
    <div class="expand-replies text-center">
        <button class="btn btn-sm" [disabled]="!parent.loadedThread" (click)="loadMoreReplies(true)">
            <span translate>View previous replies</span>
            ({{ defaultCount + threadFilterService.collapseOptions.takeReplies }} <span translate>of</span>
            {{ repliesCount }})
        </button>
    </div>
}
